import '../../styles/style.css'

const OtherProjects = () => {
  return (
    // <!-- Other Projects -->
        <>
            <div className="otherProjectsContent">
                <h1 className="heading1">More Projects</h1>
                <p className="descriptionText">Some more projects I've made and been involved in</p>

                <div className="social-icons">
                    <a target="_blank" href="https://github.com/DerisO22"><i className='bx bxl-github'></i></a>
                </div>
            </div>

            {/* <!-- Reuse Elements --> */}
            <div className="imageExampleContainerHCI">
                <div className="image1_container">
                    <img className="example_moreProjects_image1" src="/otherprojects_assets/collegeEthicsExample.webp" alt="College Ethics Game"></img>
                    <div className="phonici_example1_overlay">
                        <div className="overlayContentContainer">
                            <div className="overlay_text">College Ethics Game being used in first year COR classNamees</div>
                            <button className="projectButton" onClick={() => window.open('https://adventureproject.vercel.app', '_blank')}>Check it out</button>
                        </div>
                    </div>
                </div>
                <div className="image2_container">
                    <img className="example_moreProjects_image2" src="/otherprojects_assets/projectOctopusExample.webp" alt="Start Screen to 2.5D Godot Game"></img>
                    <div className="phonici_example2_overlay">
                        <div className="overlayContentContainer">
                            <div className="overlay_text">Open-Source 2.5D Survival Game Using Godot</div>
                            <button className="projectButton" onClick={() => window.open('https://github.com/AkivaNugent/CSI-280_PROJECT-OCTOPUS', '_blank')}>Check it out</button>
                        </div>
                    </div>
                </div>
                <div className="image3_container">
                    <img className="example_moreProjects_image3" src="/otherprojects_assets/chessExample.webp" alt="Chess Pawn Icon"></img>
                    <div className="phonici_example3_overlay">
                        <div className="overlayContentContainer">
                            <div className="overlay_text">Chess Game using C++</div>
                            <button className="projectButton" onClick={() => window.open('https://github.com/DerisO22/Chess-Game', '_blank')}>Check it out</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bottomTextOtherProjects">Check out my GitHub for More Projects</div>
        </>
    )
}

export default OtherProjects;